export { AnchoredPopup, default } from './AnchoredPopup';
export type { AnchoredPopupPlacement, AnchoredPopupProps } from './types';
